import { Badge } from "@/components/ui/badge";

import {
  placementStatusToBackgroundColor,
  placementStatusToDotColor,
  placementStatusToHoverBackgroundColor,
  placementStatusToLabel,
} from "@/lib/constants";
import { cn } from "@/lib/utils";
import { PlacementStatus } from "@/types";

export const PlacementStatusBadge = ({
  className,
  status,
}: {
  className?: string;
  status: PlacementStatus;
}) => {
  return (
    <Badge
      variant="secondary"
      className={cn(
        "gap-2 font-normal",
        placementStatusToBackgroundColor[status],
        placementStatusToHoverBackgroundColor[status],
        className,
      )}
    >
      <span
        className={cn("h-2 w-2 rounded-full", placementStatusToDotColor[status])}
      />
      {placementStatusToLabel[status]}
    </Badge>
  );
};
